import Ajax from '../ajax';

export default {
  list: (days) => Ajax('get', `dashboard/${days}`),
};
